import { ModalDrawerControllerProps } from '@economic/gaudi';
import React from 'react';
import { FormSpy } from 'react-final-form';

import { SendByType } from '../../invoices/book-and-send/types';

interface Props {
    drawer: ModalDrawerControllerProps;
}

export function AutoCloseDrawer({ drawer }: Props) {
    return (
        <FormSpy
            subscription={{ values: true }}
            component={({ values }) => {
                if (values.sendByType === SendByType.email) {
                    drawer.show();
                } else if (drawer.visible) {
                    drawer.hide();
                }
                return null;
            }}
        />
    );
}
